<template>
    <div>
        <el-form :inline="true" :model="queryParams" size="small" style="text-align: left; margin-top: 5px">
            <el-form-item label="学校选择">
                <el-select v-model="queryParams.schoolId" placeholder="请选择学校" :clearable="!schoolLocked" filterable :disabled="schoolLocked" @change="onSchoolChange">
                    <el-option
                            v-for="item in schoolList"
                            :key="item.schoolId"
                            :label="item.schoolName"
                            :value="item.schoolId">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>

        <el-form :inline="true" :model="ruleForm" size="small" style="text-align: left; margin-bottom: 4px">
            <el-form-item label="入账比例">
                <el-input-number v-model="ruleForm.earnRate" :min="0.01" :precision="2" :step="0.1" :disabled="!queryParams.schoolId" />
            </el-form-item>
            <el-form-item label="启用入账">
                <el-switch v-model="ruleForm.enabled" active-value="1" inactive-value="0" :disabled="!queryParams.schoolId" />
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="mini" :loading="ruleSaving" :disabled="!queryParams.schoolId" @click="saveRule">保存规则</el-button>
            </el-form-item>
        </el-form>
        <div class="point-rule-hint">
            微信支付成功后按「实付金额（元）× 入账比例」向下取整加积分，未支付不加分。
            当前比例 {{ displayEarnRate }} 表示支付 1 元得 {{ displayEarnRate }} 分，例如支付 3.6 元得 {{ examplePoints }} 分。
            关闭入账后新支付不再加分；退款按同一公式冲正，余额不够则扣到 0。
        </div>

        <el-form :inline="true" :model="queryParams" size="small" style="text-align: left">
            <el-form-item label="用户ID">
                <el-input v-model="queryParams.userId" placeholder="用户ID" clearable @keyup.enter.native="getList" />
            </el-form-item>
            <el-form-item label="手机号">
                <el-input v-model="queryParams.userPhone" placeholder="手机号" clearable @keyup.enter.native="getList" />
            </el-form-item>
            <el-form-item label="业务类型">
                <el-select v-model="queryParams.bizType" placeholder="全部" clearable>
                    <el-option label="支付入账" value="ORDER_PAY" />
                    <el-option label="退款冲正" value="ORDER_REFUND" />
                    <el-option label="兑换" value="EXCHANGE" />
                    <el-option label="手工调账" value="ADMIN_ADJUST" />
                </el-select>
            </el-form-item>
            <el-form-item label="时间">
                <el-date-picker
                        v-model="logTime"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        align="right">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="mini" :disabled="!queryParams.schoolId" @click="getList">查询</el-button>
                <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
                <el-button type="warning" size="mini" :disabled="!queryParams.schoolId" @click="openAdjust">手工调账</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="list" border style="width: 100%">
            <el-table-column label="时间" prop="createTime" align="center" width="170" />
            <el-table-column label="用户ID" prop="userId" align="center" width="90" />
            <el-table-column label="昵称" prop="jpNickName" align="center" min-width="120" :show-overflow-tooltip="true" />
            <el-table-column label="手机号" prop="jpPhone" align="center" width="130" />
            <el-table-column label="变动" prop="changeNum" align="center" width="90" />
            <el-table-column label="余额" prop="balanceAfter" align="center" width="90" />
            <el-table-column label="类型" prop="bizType" align="center" width="130">
                <template slot-scope="scope">{{ bizTypeLabel(scope.row.bizType) }}</template>
            </el-table-column>
            <el-table-column label="业务单号" prop="bizId" align="center" min-width="160" :show-overflow-tooltip="true" />
            <el-table-column label="备注" prop="remark" align="center" min-width="180" :show-overflow-tooltip="true" />
        </el-table>

        <el-pagination
                style="margin-top: 16px; text-align: right"
                layout="total, prev, pager, next"
                :current-page="queryParams.pageNum"
                :page-size="queryParams.pageSize"
                :total="total"
                @current-change="handlePageChange">
        </el-pagination>

        <el-dialog title="手工调账" :visible.sync="adjustOpen" width="460px" @close="resetAdjust">
            <el-form ref="adjustForm" :model="adjustForm" :rules="adjustRules" label-width="90px" size="small">
                <el-form-item label="用户ID" prop="userId">
                    <el-input-number v-model="adjustForm.userId" :min="1" :precision="0" style="width: 100%" />
                </el-form-item>
                <el-form-item label="积分" prop="changeNum">
                    <el-input-number v-model="adjustForm.changeNum" :precision="0" style="width: 100%" />
                    <div style="color:#909399;font-size:12px;">正数加分，负数扣分，不能为 0</div>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input v-model="adjustForm.remark" type="textarea" :rows="3" maxlength="200" show-word-limit />
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="adjustOpen = false">取 消</el-button>
                <el-button type="primary" :loading="adjustLoading" @click="submitAdjust">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { isSchoolScoped, getBoundSchoolId, lockSchoolOptions } from '@/utils/schoolScope'
export default {
    name: 'Point',
    computed: {
        schoolLocked() {
            return isSchoolScoped()
        },
        displayEarnRate() {
            const rate = Number(this.ruleForm.earnRate)
            if (!rate || rate <= 0) {
                return '1.00'
            }
            return rate.toFixed(2)
        },
        examplePoints() {
            const rate = Number(this.ruleForm.earnRate)
            const used = !rate || rate <= 0 ? 1 : rate
            return Math.floor(3.6 * used)
        }
    },
    data() {
        const notZero = (rule, value, callback) => {
            if (value === undefined || value === null || value === '') {
                callback(new Error('请输入积分'))
            } else if (Number(value) === 0) {
                callback(new Error('调账积分不能为 0'))
            } else {
                callback()
            }
        }
        return {
            schoolList: [],
            list: [],
            total: 0,
            logTime: [],
            ruleSaving: false,
            adjustOpen: false,
            adjustLoading: false,
            queryParams: {
                schoolId: null,
                userId: '',
                userPhone: '',
                bizType: '',
                beginTime: '',
                endTime: '',
                pageNum: 1,
                pageSize: 10
            },
            ruleForm: {
                earnRate: 1,
                enabled: '1'
            },
            adjustForm: this.emptyAdjust(),
            adjustRules: {
                userId: [{ required: true, message: '请输入用户ID', trigger: 'blur' }],
                changeNum: [{ required: true, validator: notZero, trigger: 'blur' }],
                remark: [{ required: true, message: '请输入备注', trigger: 'blur' }]
            }
        }
    },
    created() {
        this.getSchoolList()
    },
    methods: {
        emptyAdjust() {
            return {
                userId: undefined,
                changeNum: undefined,
                remark: ''
            }
        },
        bizTypeLabel(bizType) {
            const map = {
                ORDER_PAY: '支付入账',
                ORDER_REFUND: '退款冲正',
                EXCHANGE: '兑换',
                ADMIN_ADJUST: '手工调账'
            }
            return map[bizType] || bizType || '-'
        },
        async getSchoolList() {
            const res = await this.$http.get('/school/AppGetCampusSchoolList')
            if (res.data.code === 200) {
                this.schoolList = lockSchoolOptions(res.data.data || [])
                if (isSchoolScoped() && getBoundSchoolId() != null) {
                    this.queryParams.schoolId = getBoundSchoolId()
                    this.onSchoolChange()
                }
            }
        },
        onSchoolChange() {
            this.queryParams.pageNum = 1
            if (!this.queryParams.schoolId) {
                this.ruleForm.earnRate = 1
                this.ruleForm.enabled = '1'
                this.list = []
                this.total = 0
                return
            }
            this.loadRule()
            this.getList()
        },
        async loadRule() {
            const res = await this.$http.get('/admin/point/rule/get', { params: { schoolId: this.queryParams.schoolId } })
            if (res.data.code === 200) {
                const rule = res.data.data || {}
                this.ruleForm.earnRate = rule.earnRate != null ? Number(rule.earnRate) : 1
                this.ruleForm.enabled = rule.enabled === '0' ? '0' : '1'
            } else {
                this.$message.error(res.data.msg || '读取规则失败')
            }
        },
        async saveRule() {
            if (!this.queryParams.schoolId) {
                this.$message.warning('请选择学校')
                return
            }
            if (this.ruleForm.earnRate == null || Number(this.ruleForm.earnRate) <= 0) {
                this.$message.warning('入账比例必须大于 0')
                return
            }
            this.ruleSaving = true
            try {
                const res = await this.$http.post('/admin/point/rule/save', {
                    schoolId: this.queryParams.schoolId,
                    earnRate: this.ruleForm.earnRate,
                    enabled: this.ruleForm.enabled
                })
                if (res.data.code === 200) {
                    this.$message.success('规则已保存')
                    this.loadRule()
                } else {
                    this.$message.error(res.data.msg || '保存失败')
                }
            } finally {
                this.ruleSaving = false
            }
        },
        buildLogParams() {
            const params = {
                schoolId: this.queryParams.schoolId,
                userPhone: this.queryParams.userPhone,
                bizType: this.queryParams.bizType,
                pageNum: this.queryParams.pageNum,
                pageSize: this.queryParams.pageSize
            }
            if (this.queryParams.userId !== '' && this.queryParams.userId != null) {
                params.userId = this.queryParams.userId
            }
            if (this.logTime && this.logTime.length === 2) {
                params.beginTime = this.logTime[0]
                params.endTime = this.logTime[1]
            }
            return params
        },
        async getList() {
            if (!this.queryParams.schoolId) {
                this.$message.warning('请选择学校')
                return
            }
            const res = await this.$http.get('/admin/point/log/list', { params: this.buildLogParams() })
            if (res.data.code === 200) {
                const page = res.data.data || {}
                this.list = page.children || []
                this.total = page.total || 0
            } else {
                this.$message.error(res.data.msg || '查询失败')
            }
        },
        resetQuery() {
            this.queryParams.userId = ''
            this.queryParams.userPhone = ''
            this.queryParams.bizType = ''
            this.logTime = []
            this.queryParams.pageNum = 1
            if (!this.schoolLocked) {
                this.queryParams.schoolId = null
                this.ruleForm.earnRate = 1
                this.ruleForm.enabled = '1'
                this.list = []
                this.total = 0
                return
            }
            this.onSchoolChange()
        },
        handlePageChange(page) {
            this.queryParams.pageNum = page
            this.getList()
        },
        openAdjust() {
            if (!this.queryParams.schoolId) {
                this.$message.warning('请选择学校')
                return
            }
            this.adjustForm = this.emptyAdjust()
            this.adjustOpen = true
        },
        resetAdjust() {
            this.adjustForm = this.emptyAdjust()
            if (this.$refs.adjustForm) {
                this.$refs.adjustForm.clearValidate()
            }
        },
        submitAdjust() {
            this.$refs.adjustForm.validate(async valid => {
                if (!valid) {
                    return
                }
                this.adjustLoading = true
                try {
                    const res = await this.$http.post('/admin/point/adjust', {
                        schoolId: this.queryParams.schoolId,
                        userId: this.adjustForm.userId,
                        changeNum: this.adjustForm.changeNum,
                        remark: this.adjustForm.remark
                    })
                    if (res.data.code === 200) {
                        this.$message.success('调账成功')
                        this.adjustOpen = false
                        this.getList()
                    } else {
                        this.$message.error(res.data.msg || '调账失败')
                    }
                } finally {
                    this.adjustLoading = false
                }
            })
        }
    }
}
</script>

<style scoped>
.point-rule-hint {
    color: #909399;
    font-size: 12px;
    line-height: 1.6;
    text-align: left;
    margin: 0 0 16px 0;
    max-width: 920px;
}
</style>
